<template>
  <div @click="updateSelectTagsState(false);updateSearchTagsState(false)">
    <div class="JobEdit">
      <!-- 公司详情 -->
      <div class="company flex-c bg_fff">
        <div class="formTitle f_16 color_40 pr">公司信息</div>
        <a class="companyCont flex1 cursor_p" href="/talent/company" target="_blank">
          <div class="name f_18 color_0 ellipsis">{{companyInfo.company_full_name}}</div>
          <div class="desc f_16 color_a9 ellipsis">{{companyInfo.description_hr || companyInfo.description}}</div>
        </a>
        <img :src="companyInfo.logo_hr || companyInfo.logo" :alt="companyInfo.company_full_name" class="logo cursor_p"
             @click="$router.push({path:`/talent/company`})">
      </div>

      <!-- 职位信息表单 -->
      <div class="formBox bg_fff" v-loading="isloading">

        <!-- 基本信息 -->
        <div class="formTitle f_16 color_40 pr">基本信息</div>
        <div class="formItem">
          <div class="item flex w445 pr" ref="errorTips_job_post">
            <div class="name f_14 color_9c">职位名称：</div>
            <div class="flex1">
              <div class="pr">
                <el-input class="restInput f_14 color_40" :class="[errorTips.job_post?'error':'']"
                          v-model="formData.job_post" placeholder="请输入职位名称，如：产品经理" :maxlength="20"
                          @focus="inputFocus('job_post')" @blur="levelChange('job_post')"></el-input>
                <div class="f_12 color_9c pa job_post_num"><span class="color_40">{{formData.job_post.length}}</span>/20</div>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.job_post">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.job_post}}</span>
              </div>
            </div>
          </div>

          <div class="item flex pr" ref="errorTips_cities">
            <div class="name f_14 color_9c">工作地点：</div>
            <div class="flex1">
              <div class="flex pr">
                <div style="width:148px;margin-right:8px;">
                  <el-autocomplete class="restInput f_14 color_40" :class="[formData.cities?'error':'']"
                                   popper-class="searchCompany" :maxlength="10" placeholder="所在城市"
                                   v-model="formData.cities" :fetch-suggestions="citySearch" @select="handleCity"
                                   @blur="cityBlur" @focus="inputFocus('cities')">
                    <template slot-scope="{item}">
                      <div class="name" v-if="item">
                        <span v-html="item.highlight"></span>
                        <!-- <span v-html="cityHtml(item)"></span> -->
                      </div>
                    </template>
                  </el-autocomplete>
                </div>
                <!-- 选择城市 -->
                <coordinate @updateErrorTips='updateErrorTips'/>
                <!-- <el-input class="restInput f_14 color_40 flex1" :class="[errorTips.addresses?'error':'']" v-model="formData.addresses" placeholder="详细地址" :maxlength="50" @focus="inputFocus('addresses')"></el-input> -->
                <!-- <div class="formTips f_12 color_9c pa">*详细地址50字以内</div> -->
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.cities">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.cities}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 职位要求 -->
        <div class="formTitle f_16 color_40 pr">职位要求</div>
        <div class="formItem">
          <div class="item flex pr">
            <div class="name f_14 color_9c">招聘类型：</div>
            <div class="flex1 clearfix job_nature f_14 color_90 text_center">
              <div class="type fl cursor_p" :class="[formData.job_nature==='全职'?'active color_blue' :'']"
                   @click="toggleJobNature('全职')">全职
              </div>
              <!-- <div class="type fl cursor_p" :class="[formData.job_nature==='兼职'?'active color_blue' :'']"
                   @click="toggleJobNature('兼职')">兼职
              </div> -->
              <div class="type fl cursor_p" :class="[formData.job_nature==='实习'?'active color_blue' :'']"
                   @click="toggleJobNature('实习')">实习
              </div>
              <div class="type fl cursor_p" :class="[formData.job_nature==='校招'?'active color_blue' :'']"
                   @click="toggleJobNature('校招')">校招
              </div>
            </div>
          </div>
          <div class="item flex w445" ref="internship-requirements-box" v-if="formData.job_nature === '实习'">
            <div class="name f_14 color_9c">实习要求：</div>
            <div class="flex1">
              <div class="flex">
                <el-select class="restSelect f_14 color_40 flex1" v-model="formData.intern_duration" style="margin-right:16px"  placeholder="最少实习月份">
                  <el-option
                      v-for="item in search_conditions.internshipMonths"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
                <div class="myInput flex1 pr">
                  <el-select class="restSelect f_14 color_40 flex1" v-model="formData.intern_frequency" placeholder="每周实习天数">
                    <el-option
                        v-for="item in search_conditions.internshipDays"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                  </el-select>
                  <div class="tips pa f_14 color_9c">
                    <span>天/周</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item flex w445" ref="errorTips_experience_degree_id">
            <div class="name f_14 color_9c">经验学历：</div>
            <div class="flex1">
              <div class="flex">
                <el-select class="restSelect f_14 color_40 flex1" @change="getExperienceDegreeId('experience')"
                           style="margin-right:16px"
                           :disabled="formData.job_nature === '校招'"
                           v-model="formData.experience" placeholder="经验要求" v-if="formData.job_nature!=='实习'">
                  <el-option
                      v-for="item in search_conditions.experiences"
                      :key="item[0]"
                      :label="item[1]"
                      :value="item[0]">
                  </el-option>
                </el-select>
                <el-select class="restSelect f_14 color_40 flex1" @change="getExperienceDegreeId('degree_id')"
                           v-model="formData.degree_id" placeholder="学历要求">
                  <el-option
                      v-for="item in search_conditions.degrees"
                      :key="item[0]"
                      :label="item[1]"
                      :value="item[0]">
                  </el-option>
                </el-select>
              </div>
              <div class="errorTipsDesc f_14" v-if="errorTips.experience_degree_id">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.experience_degree_id}}</span>
              </div>
            </div>
          </div>
          <div class="item flex pr" ref="errorTips_salary_min">
            <div class="name f_14 color_9c">薪资范围：</div>
            <div class="flex1">
              <div class="flex">
                <div class="myInput flex1 pr">
                  <el-select class="restInput f_14 color_40" v-model="formData.salary_min" @change="getSalaryMaxList"
                             placeholder="最低薪资">
                    <el-option
                        v-for="item in salaryMinList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                  <div class="tips pa f_14 color_9c">
                    <span v-if="formData.job_nature==='全职' || formData.job_nature==='校招'">K/月</span>
                    <span v-else>元/天</span>
                  </div>
                </div>
                <p class='f_14 color_40 text_center myInput-'
                   :class="[formData.salary_min==='' || (formData.salary_min===100 && (formData.job_nature==='全职'|| formData.job_nature==='校招')) ? 'opacity0' : '']">
                  至</p>
                <div class="myInput flex1 pr"
                     :class="[formData.salary_min==='' || (formData.salary_min===100 && (formData.job_nature==='全职'|| formData.job_nature==='校招')) ? 'opacity0' : '']">
                  <el-select class="restInput f_14 color_40" v-model="formData.salary_max" placeholder="最高薪资">
                    <el-option
                        v-for="item in salaryMaxList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
<!--                  aaaa-->
                  <div class="tips pa f_14 color_9c">
                    <span v-if="formData.job_nature==='全职' || formData.job_nature==='校招'">K/月</span>
                    <span v-else>元/天</span>
                  </div>
                </div>
                <p class='f_14 color_40 text_center myInput-'
                   :class="[formData.salary_min && formData.job_nature !== '实习' && showManySalary? '' : 'opacity0']">
                  ×</p>
                <div class="myInput flex1 pr"
                     :class="[formData.salary_min && formData.job_nature !== '实习' && showManySalary? '' : 'opacity0']">
                  <el-select class="restInput f_14 color_40" v-model="formData.annual_month_salary" placeholder="薪资数量">
                    <el-option
                      v-for="item in monthSalaryOption"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                  <div class="tips pa f_14 color_9c">
                    <span v-if="formData.job_nature !== '实习'">薪/年</span>
                  </div>
                </div>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.salary_min">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.salary_min}}</span>
              </div>
            </div>

          </div>

          <div class="item flex pr" ref="errorTips_jd">
            <div class="name f_14 color_9c">职位描述：</div>
            <div class="flex1">
              <div class="pr">
                <el-input class="restInput textarea"
                          type="textarea"
                          :rows="6"
                          :maxlength="1600"
                          resize="horizontal"
                          placeholder="请输入职位描述，建议尽量使用短句分并条列出，如下：
    职位描述：
    1、…
    2、…
    3、…
    "
                          v-model="formData.jd" @focus="inputFocus('jd')" @blur="levelChange('jd')">
                </el-input>
                <div class="textLength pa f_14 color_60 bg_fff">{{formData.jd.length}}/1600</div>
                <a href="/talent/jd_temps" target="_blank" class="pa template-a"><i class="iconfont iconfile-text" style="font-size: 14px"></i>看看职位模版</a>
                <div class="formTips f_12 color_9c pa">*职位描述不少于50字</div>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.jd">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.jd}}</span>
              </div>
            </div>

          </div>

          <template v-if="showLevelState">
            <div class="item flex pr" ref="errorTips_profession_id">
              <div class="name f_14 color_9c">职位类别：</div>
              <div class="flex1">
                <div class="restInput button f_14 cursor_p placeholder" v-if="!professionSelect.level3"
                     @click="updateSelectProfessionState(true);errorTips.profession_id=''">请选择职位类别
                </div>
                <div class="restInput button f_14 cursor_p color_40" v-else
                     @click="updateSelectProfessionState(true);errorTips.profession_id=''">{{professionSelect.level3}}
                </div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.profession_id">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.profession_id}}</span>
                </div>
              </div>
            </div>
            <div class="item flex pr" ref="errorTips_job_tags">
              <div class="name f_14 color_9c">职位关键词：</div>
              <div class="flex1 pr">
                <!-- 职位标签 -->
                <job-tags @updateErrorTips="updateErrorTips" @jobBrightSpot="jobBrightSpotFunc"/>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.job_tags">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.job_tags}}</span>
                </div>
              </div>
            </div>
          </template>
          <template>
            <div class="item flex pr" ref="welfare_job_tags">
              <div class="name f_14 color_9c">职位亮点：</div>
              <div class="flex1 pr">
                <!-- 职位亮点 -->
                <bright-tags @updateList="(list) => formData.job_highlights = list" :value="formData.job_highlights" :type="formData.job_nature" @jobBrightSpot="jobBrightSpotFunc" :jobBrightSpotVisible="jobBrightSpotVisible"/>
              </div>
            </div>
          </template>

        </div>

        <!-- 投递要求 -->
        <div class="formTitle f_16 color_40 pr" v-if="formData.job_nature === '校招'">投递要求</div>
        <div class="formItem width_696" v-if="formData.job_nature === '校招'">

          <!-- 招聘截止时间： -->
          <div class="item flex" ref="errorTips_deadline">
            <div class="name f_14 color_9c">投递截止：</div>
            <div class="flex1">
                <el-date-picker
                  class="width_324"
                  v-model="formData.deadline"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="点击选择招聘截止时间"
                  :picker-options="pickerOptions"
                  @change="errorTips.deadline = ''">
                </el-date-picker>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.deadline">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.deadline}}</span>
                </div>
            </div>
          </div>

          <!-- 毕业时间 -->
          <div class="item flex" ref="errorTips_graduate_times">
            <div class="name f_14 color_9c">毕业时间：</div>
            <div class="flex1">
              <div class="graduation-box">
                <div class="graduation-year" :class="{'active-year': activeGraduationYear[index]}" v-for="(item, index) in graduationTimeArr" :key="'graduationTime&' + item" @click="handleClickGraduationYear(item)">
                  {{ item }}届
                </div>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="errorTips.graduate_times">
                <span class="iconfont icontishi"></span>
                <span class="tipsName">{{errorTips.graduate_times}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div  class="emailTips f_14 color_40" style="margin-bottom: -27px; display: flex; align-items: center;margin-top: 43px" v-if="pageType === 'create'">
          <el-checkbox v-model="formData.is_sync" style="margin-top: 5px"></el-checkbox>
          <div style="margin-left: 4px">
            将职位同步到社区，获得更多候选人投递
            <span class="iconfont iconwenhao">
              <div class="bbs-hint">
                开启该功能后，您发布的职位将自动同步至求职社区中，目标求职者将在浏览社区时看到该职位信息，预计职位曝光率最多提高30%。
              </div>
            </span>
          </div>
        </div> -->
        <div class="emailTips f_14 color_40" v-if="formData.email && !firstEditEmail">简历将发送到
          {{formData.email}}，如需要更改邮箱，请在【我的】-【个人信息】中修改
        </div>
        <template v-else>
          <div class="formTitle f_16 color_40 pr">投递邮箱</div>
          <div class="formItem" ref="errorTips_email">
            <div class="item flex pr w445">
              <div class="name f_14 color_9c">邮箱地址：</div>
              <div class="flex1">
                <p class="emailText f_14 color_40 cursor_p" @click="toggleBindEmailState(true)" v-if="formData.email">
                  {{formData.email}}</p>
                <div class="restInput button f_14 cursor_p placeholder" @click="toggleBindEmailState(true)" v-else>
                  请输入邮箱地址
                </div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="errorTips.email">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{errorTips.email}}</span>
                </div>
              </div>
            </div>
          </div>
        </template>

        <div class="formButtons templateButtons text_center clearfix">
          <!-- <div class="saveButton fl f_16" @click="saveForm" v-if="jobStatus!=='publish' && jobStatus!=='expired'"><span class="el-icon-loading" v-if="saveFormState"></span> 保存</div> -->
          <div class="confirmButton f_16 fl" @click="checkForm">
            <span class="el-icon-loading" v-if="checkFormState"></span> 下一步
          </div>
        </div>
      </div>

      <!-- 弹出提示框 -->
      <tips-block v-if="tipsShowState" :tipsState="tipsState" @hideTipsF="hideTips"/>


      <!-- 绑定邮箱弹层 -->
      <div class="bindEmailTips" v-if="showBindEmailState" @click="toggleBindEmailState(false)">
        <div class="tipsContent pa bg_fff" @click.stop>
          <div class="tipsTitle f_18 color_40 font_w_b">投递邮箱</div>

          <div class="form">
            <dl class="formItem flex" :class="[emailErrorTips.email?'errorTips':'']">
              <dt class="f_14 color_60"><span>公司邮箱</span>：</dt>
              <dd class="flex1">
                <el-input class="restInput f_14 color_40" v-model="emailData.email" placeholder="请输入你的公司邮箱"
                          @focus="inputFocus2('email')" :maxlength="64"></el-input>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="emailErrorTips.email">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{emailErrorTips.email}}</span>
                </div>
              </dd>
            </dl>
            <dl class="formItem flex" :class="[emailErrorTips.code?'errorTips':'']">
              <dt class="f_14 color_60"><span>验证码</span>：</dt>
              <dd class="flex1">
                <div class="codeBox flex-c">
                  <el-input class="restInput f_14 color_40 flex1" v-model="emailData.code" placeholder="请输入验证码"
                            @focus="inputFocus2('code')" :maxlength="6"></el-input>
                  <div class="time cursor_p text_center f_14">
                    <span class="color_blue" @click="getCode()" v-if="time === 60">发送验证码</span>
                    <span class="color_90" v-else>{{time}}s</span>
                  </div>
                </div>
                <!-- 错误提示 -->
                <div class="errorTipsDesc f_14" v-if="emailErrorTips.code">
                  <span class="iconfont icontishi"></span>
                  <span class="tipsName">{{emailErrorTips.code}}</span>
                </div>
              </dd>
            </dl>
<!--            <div class="bindEmailCode f_14 color_9c"><span class="cursor_p" @click="showEmailBind">无法收到验证码？</span></div>-->
            <div class="bindEmailCode f_14 color_9c"></div>
          </div>
          <div class="formButtons clearfix">
            <div class="fr confirm text_center bg_current color_fff f_14 cursor_p" @click="bindEmail()">确定</div>
            <div class="fr cancel text_center color_60 f_14 cursor_p" @click="toggleBindEmailState(false);">取消</div>
          </div>
        </div>
      </div>

      <userBindEmail v-if="emailBindState" :email='emailData.email' :errorState="emailBindErrorState"
                     @hideUserBindEmailState="hideUserBindEmailState" @confirm="bindEmailConfirm"
                     @hideEmailBindError='hideEmailBindError'/>

      <!-- 选择职位类别 -->
      <selectProfession v-if="selectProfessionState" :selectProfessionList="selectProfessionList"/>

      <!-- 发布火爆职位支付弹窗 -->
      <!-- <job-pay-dialog v-if="payDialogVisible"
                      type="hot"
                      payType="bJobHot"
                      title="火爆职位"
                      :subtitle="`有效期：${ moment().format('YYYY-MM-DD') } 至 ${ moment().add(30, 'd').format('YYYY-MM-DD') }`"
                      tipsText="火爆职位：该类职位HR竞争较为激烈，需要付费发布<br />该类产品为数字化商业产品，一经售出不支持退款退货"
                      :orderToken="orderToken"
                      :orderPriceText="99"
                      @paidFunc="paidFunc"
                      @closeFunc="closePayDialog" /> -->
      <mix-job-pay 
          v-if="payDialogVisible"
          :jobTitle="formData.job_post"
          :jobToken="jobToken"
          :subtitle="`有效期：${ moment().format('YYYY-MM-DD') } 至 ${formData.job_nature == '校招' ? moment(formData.deadline).format('YYYY-MM-DD') : moment().add(29, 'd').format('YYYY-MM-DD')}`"
          :nowOrderToken="orderToken"
          :job_nature="formData.job_nature"
          :formData="formData"
          @paidFunc="paidFunc"
          @closeFunc="closePayDialog"
      ></mix-job-pay>

      <!-- 关闭支付弹窗二次确认弹窗 -->
      <confirm-dialog v-if="confirmDialogVisible"
                      tipsTitle="职位尚未发布"
                      tipsText="当前职位尚未发布成功，是否要继续发布？"
                      confirmButtonText="继续发布"
                      cancelButtonText="暂不发布"
                      @confirmFunc="confirmDialogConfirm"
                      @cancelFunc="confirmDialogCancel" />

    </div>
  </div>
</template>

<script>
  // 所有接口
  import moment from 'moment'
  import actions from '@/actions/index'
  import {mapState, mapMutations} from 'vuex'
  import {getCookieValue, get_tUser} from '@/utils/utils'
  import {cityData} from './city'
  import company_options from '@/utils/company_options'
  import {conditions} from './conditions.js'

  import TipsBlock from '../components/TipsBlock';
  import userBindEmail from '@/components/block/UserBindEmail'
  import selectProfession from '@/components/jobEdit/selectProfession'
  import coordinate from '@/components/jobEdit/coordinate'
  import jobTags from '@/components/jobEdit/jobTags'
  import brightTags from '@/components/jobEdit/brightTags'
  // import jobPayDialog from '@/components/block/JobPayDialog'
  import confirmDialog from '@/components/block/TipsBlock'
  import MixJobPay from '@/components/block/mixJobPay.vue'


  export default {
    name: 'JobEdit',
    data() {
      return {
        showManySalary:false,//是否显示薪/年
        moment,
        pageType: 'create',
        jobStatus: '', //当前职位的状态
        formData: {
          id: '',
          salary_type: '月薪', //日薪/月薪
          salary_min: '', //薪水下限
          salary_max: '', //薪水上限
          experience: '', //,分开 以年为单位
          status: '',//publish draft 职位状态
          profession_id: '',//profession id
          job_post: '',//职位名称
          jd: '',//职位描述
          email: '',//邮箱地址
          degree_id: '',//学历id
          job_nature: '全职',//全职/兼职
          addresses: '',//工作地点
          positions: '', //坐标
          cities: '',//工作地点
          city_ids: '',//工作地点
          job_tags: [],//职位标签
          intern_duration: '3个月',//实习几个月
          intern_frequency: 5,//每周实习几天
          job_highlights: [],//职位亮点
          deadline: '', // 投递截止日期
          // graduate_times: [moment().format('YYYY')], // 毕业时间
          graduate_times: [], // 毕业时间
          annual_month_salary: 12, // 每年薪资数量（十几薪）
          is_sync: false
        },
        errorTips: {
          profession_id: '',//profession id
          job_post: '',//职位名称
          jd: '',//职位描述
          addresses: '',//工作地点
          experience_degree_id: "",//工作经验,学历
          cities: '',//工作地点
          email: '',//邮箱
          job_tags: '',//职位标签
          salary_min: '', //薪资范围
          deadline: '', // 投递截止日期
          graduate_times: '' // 毕业时间
        },

        // selectProfessionList:[],
        professionData: [],//职位类型
        // professionList:[],//职位类型
        // professionProps: {//职位类型
        //   value: 'id',
        //   label:'label',
        //   children: 'jd_temps'
        // },


        searchIngCityList: [],//城市筛选列表
        search_conditions: { //各种筛选项
          nature: [],
          industries: [],
          degrees: [],
          scales: [],
          salaries: [],
          experiences: [],
          internshipMonths: [],
          internshipDays: []
        },
        company: {
          havaInfo: false,
          id: '',
          intro: "",
          logo: "",
          name: "",
        },
        userInfo: {}, //用户信息
        companyInfo: {}, //公司信息
        saveCompanyInfo: {}, //保存的公司信息
        salaryMinList: [], //薪水下限数组
        salaryMaxList: [], //薪水上限数组

        tipsState: 1,//提示状态，1信息不完整，2超出最大数量，3重复职位
        tipsShowState: false,//是否展示提示框

        firstEditEmail: true,//是否是第一次更改邮箱
        emailData: {//邮箱数据
          email: '',
          code: '',
        },
        emailErrorTips: {
          email: '',
          code: '',
        },
        showBindEmailState: false, //显示绑定邮箱
        getCodeState: false, //获取验证码的状态
        time: 60,
        timeName: '',
        cannotEmail: ['@qq.com', '@163.com', '@126.com', '@gmail', 'outlook.com', '@hotmail.com', '.edu', '@sohu.com', '@sina.com'],//不能输入的邮箱

        userJWT: {},
        jd_temp: '', // 模板信息

        emailBindState: false,//手动绑定弹层显示状态
        emailBindEdit: '',//是否是修改邮箱
        emailBindErrorState: false,//错误状态提示

        saveFormState: false, //表单保存状态
        checkFormState: false,//表单发布状态
        isloading: true,
        jobPostBlurTimeName: null, //根据职位名称获取职位类型定时器，
        jobPostBlurTimeState: false, //根据职位名称获取职位类型定时器是否执行中
        showLevelState: false, //是否显示职位类别/关键词

        payDialogVisible: false, // 是否显示支付弹窗
        confirmDialogVisible: false, // 是否显示支付二次弹窗
        orderToken: null, // 订单 token
        jobToken: null, // 职位 token
        jobName: null, // 职位名称

        graduationTimeArr: [], // 存储可选毕业时间的数组
        pickerOptions: { // 日期选择器的控制参数，
          disabledDate: this.handleDisabledDate // disabledDate：日期是否可选
        },
        jobBrightSpotVisible: false
      }
    },
    watch: {
      formData: {
        deep: true,
        immediate: true,
        handler(val) {
          // console.log(val)
          if(val.salary_min === 100){
            this.showManySalary = false
          }else{
            this.showManySalary = true
          }
        }
      }
    },
    computed: {
      ...mapState('block', ['userInfoState']),
      ...mapState('jobEdit', ['selectProfessionList', 'professionSelect', 'profession_id', 'selectProfessionState', 'coordinate', 'storeCity', 'cityPoint', 'job_tags', 'userToggleProfession']),

      // 检查是否是活跃毕业年份
      activeGraduationYear () {
        let yearArr = this.graduationTimeArr
        let activeArr = this.formData.graduate_times || []

        let flagArr = yearArr.map(item => {
          let activeIndex = activeArr.indexOf(item)
          return (activeIndex !== -1)
        })
        return flagArr
      },
      // 薪资数量选择框
      monthSalaryOption() {
        let arr = []
        for (let i = 12; i < 25; i ++) {
          arr.push(i)
        }
        return arr
      }
    },
    components: {
      'tips-block': TipsBlock,
      userBindEmail,
      selectProfession,
      coordinate,
      jobTags,
      brightTags,
      // jobPayDialog,
      confirmDialog,
      MixJobPay
    },
    async created() {
      let {token} = this.$route.params;
      let {jd_temp = '', tipsState = '', tipsShowState = ''} = this.$route.query;

      this.userJWT = get_tUser();
      this.pageType = token;
      this.jd_temp = jd_temp;

      //初始化vuex
      this.resetVuex();
      if (this.userJWT.h_t) {
        //获取用户信息
        this.userInfo = await actions.hr_accounts.getUserinfo({});

        let { company_position, name, company_email, company_token } = this.userInfo
        //判断是否是第一次更改邮箱
        this.firstEditEmail = !company_email;
        //检测用户信息是否完整
        if(!(!!company_position && !!name && !!company_email && !!company_token)){
          this.$router.replace({path: `/talent/binduser`, query: { link_to: encodeURIComponent(window.location.href) }})
          return
        }else{
          //获取公司信息
          this.getCompanyData();
          // this.$router.replace({path: `/talent/company/?edit=true&backTo=${encodeURIComponent(window.location.href)}`})
        }
      } else {
        //未登录
        // console.log('未登录状态')
      }
      if (token === 'create') {

        //获取最低薪资的数据
        this.getSalaryMinList();
        //获取 最高 薪资的数据
        this.getSalaryMaxList();

        if (jd_temp) {
          //获取模板信息
          this.get_jd_temp();
        } else {
          //获取职位数据
          this.getJdTemps();
        }

        //获取最近一个职位使用的地址
        this.getLastAddress();

        //邮箱同步到表单中
        this.formData.email = this.userInfo.company_email || '';

        this.isloading = false;
      } else {
        //获取页面信息
        await this.getData();
        //获取最低薪资的数据
        this.getSalaryMinList();
        //获取 最高 薪资的数据
        this.getSalaryMaxList();
        //更新用户是否切换过职位类型
        this.updateUserToggleProfession(true);
        // 用在 编辑页面时 初始化一些行为
        this.initBehaviorEdit()
      }
      //获取页面筛选项
      this.get_search_conditions();

      // 初始化可选毕业时间（今年往前一年 至 今年往后三年，共五年）
      this.initGraduationTime()
    },
    methods: {
      ...mapMutations('block', ['updateUserBindEmailState']),
      ...mapMutations('jobEdit', ['updateSelectProfessionList', 'updateProfessionSelect', 'updateProfessionId', 'updateSelectProfessionState', 'updateCoordinate', 'updateCity', 'updateSelectTagsState', 'updateSearchTagsState', 'updateJobTags', 'updateUserCheckTags', 'updateUserAddTags', 'updateStoreJd', 'updateUserToggleProfession']),


      jobBrightSpotFunc (flag) {
        this.jobBrightSpotVisible = flag
      },
      // 日期只能选择现在或之后的时间
      handleDisabledDate (time) {
        time = this.moment(time).add(1, 'd')
        // time：日期选择器里所有可选的时间
        if (new Date(time).getTime() <= new Date().getTime()) {
          // 不可选
          return true
        } else {
          // 可选
          return false
        }
      },
      // 用在 编辑页面时 初始化一些行为
      initBehaviorEdit () {
        // 编辑进来时，判断招聘类型如果是校招，则经验要求固定为应届生并且不可选
        if (this.formData.job_nature === '校招') {
          this.formData.experience = ',0'
        }
      },
      // 检查是否是活跃毕业年份
      checkGraduationYear (year) {
        let activeArr = this.formData.graduate_times || []
        let activeIndex = activeArr.indexOf(year)
        return [(activeIndex !== -1), activeIndex]
      },
      // 选择或反选毕业年份
      handleClickGraduationYear (year) {
        // 获取当前活跃的毕业年份
        let activeArr = this.formData.graduate_times || []
        let [activeFlag, activeIndex] = this.checkGraduationYear(year)
        if (activeFlag) {
          // activeArr 里找的到相同的值，所以是删除
          activeArr.splice(activeIndex, 1)
        } else {
          // activeArr 里找不到相同的值，所以是添加
          activeArr.push(year)
          this.errorTips.graduate_times = ''
        }
        this.formData.graduate_times = activeArr
      },
      // 初始化可选毕业时间
      initGraduationTime () {
        let nowYear = Number(this.moment().format('YYYY'))
        this.graduationTimeArr = [String(nowYear - 1), String(nowYear), String(nowYear + 1), String(nowYear + 2), String(nowYear + 3)]
      },
      async getData() {
        let {jd_temp = '', tipsState = '', tipsShowState = ''} = this.$route.query;
        let res = await actions.recruit_infos.get_recruit_edit(this.pageType);
        this.isloading = false;
        if (res.code === 1000) {
          let {id, salary_type, detailed_address, job_nature, salary_min, salary_max, status, profession_id, job_post, jd, degree_id, job_city, delivery_email, experience_min, experience_max, city_names, city_ids, addresses, positions, profession_level1, profession_level2, profession_level3, job_tags, intern_duration, intern_frequency, job_highlights, deadline, graduate_times, annual_month_salary} = res.data.job;

          let cities = city_names && city_names.length ? city_names[0] : '';
          city_ids = city_ids && city_ids.length ? city_ids[0] : '';
          let address = addresses && addresses.length && positions && positions.length ? addresses[0] : '';
          positions = addresses && addresses.length && positions && positions.length ? positions[0] : '';
          job_tags = job_tags ? job_tags : [];
          //状态
          this.jobStatus = status;

          //老数据有概率 没有职位类型/最高/最低薪资
          if (job_nature === null && salary_min === null && salary_max === null) {
            job_nature = '全职'
          }
          if (job_nature === null) {
            if (salary_type === '日薪') {
              salary_min = salary_min !== null ? parseInt(salary_min / 30) : '100';
              salary_max = salary_max !== null ? parseInt(salary_max / 30) : 150;
            } else {
              // salary_min = salary_min!==null ? parseInt(salary_min/100) : 10;
              // salary_max = salary_max!==null ? parseInt(salary_max/100) : 11;
              salary_min = salary_min !== null ? parseInt(salary_min / 100) : '';
              salary_max = salary_max !== null ? parseInt(salary_max / 100) : '';
            }
          } else {
            // salary_min = job_nature==='全职' ? ( salary_min!==null ? parseInt(salary_min/1000) : 10) : ( salary_min!==null ? parseInt(salary_min/30) : 100)
            // salary_max = job_nature==='全职' ? ( salary_max!==null ? parseInt(salary_max/1000) : 11) : ( salary_max!==null ? parseInt(salary_max/30) : 150)
            salary_min = (job_nature === '全职' || job_nature === '校招') ? (salary_min !== null ? parseInt(salary_min / 1000) : '') : (salary_min !== null ? parseInt(salary_min / 30) : '')
            salary_max = (job_nature === '全职' || job_nature === '校招') ? (salary_max !== null ? parseInt(salary_max / 1000) : '') : (salary_max !== null ? parseInt(salary_max / 30) : '')
          }
          //显示职位类别/关键词
          this.showLevelState = true;

          this.formData = {
            id,
            salary_type: salary_type, //日薪/月薪
            // salary_min: job_nature==='全职' ? ( salary_min!==null ? parseInt(salary_min/1000) : 10) : ( salary_min!==null ? parseInt(salary_min/30) : 100), //薪水下限
            salary_min, //薪水下限
            salary_max: '',
            experience: (experience_min === null && experience_max === null) ? '不限' : `${experience_min !== null ? experience_min / 365 : ''},${experience_max !== null ? experience_max / 365 : ''}`, //,分开 以年为单位
            status,//publish draft 职位状态
            profession_id: profession_id || '',//profession id
            job_post: job_post || '',//职位名称
            jd: jd || '',//职位描述
            degree_id: degree_id || '不限',//学历id
            job_nature,//全职/兼职/实习
            addresses: address,//工作地点
            detailed_address, // 工作地点自定义
            positions,//工作地点-坐标
            cities,//工作地点
            city_ids,//工作地点
            email: delivery_email || '',
            job_tags,//职位标签
            intern_duration: intern_duration || '3个月',//实习几个月
            intern_frequency: intern_frequency || 5,//每周实习几天
            job_highlights: job_highlights || [],//职位亮点
            deadline: deadline || '',
            graduate_times: graduate_times || [],
            annual_month_salary: annual_month_salary || 12
          };
          //更新用户选中tag
          this.updateJobTags(job_tags);
          //同步城市数据
          this.updateCity({
            cities,
            city_ids,
          })
          //同步地址数据
          this.updateCoordinate({
            addresses: address,
            coordinate: positions, //经度, 纬度
            detailed_address
          })

          let professionData = profession_id !== null ? [profession_level1, profession_level2, profession_level3] : [];
          this.professionData = professionData;
          if (profession_id !== null) {
            //同步文案
            this.updateProfessionSelect({
              level1: profession_level1,
              level2: profession_level2,
              level3: profession_level3,
              level2ListIndex: '',
              level2ItemIndex: '',
            })
            //同步id
            this.updateProfessionId(profession_id);
            if (profession_level3) {
              let checkLevel3 = setInterval(() => {
                if (this.selectProfessionList.length) {
                  clearInterval(checkLevel3);
                  this.findSelectItem(profession_level3);
                }
              }, 500);
            }
          }
          //获取职位数据
          this.getJdTemps();

          //获取职位关键词
          // this.getJobTags();

          //需要加定时器，不然会走最低薪资的change
          setTimeout(() => {
            // this.formData.salary_max = job_nature==='全职' ? ( salary_max!==null ? parseInt(salary_max/1000) : 11) : ( salary_max!==null ? parseInt(salary_max/30) : 150) ; //薪水上限
            this.formData.salary_max = salary_max; //薪水上限
          }, 10);

          if (tipsState && (tipsState === '1' || tipsState === '2' || tipsState === '3') && tipsShowState === 'true') {
            this.tipsShowState = true;
            this.tipsState = Number(tipsState);
            history.replaceState({jd_temp: jd_temp}, null, `?jd_temp=${jd_temp}`);
            //为了走提示，直接保存
            this.checkForm();
          }


        } else {
          if (res.code === 80135) {
            //职位不存在
            this.$router.replace({path: '/talent/joblist'})
            return false;
          }
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      },
      inputFocus(type) {
        this.errorTips[type] = '';
      },
      inputFocus2(type) {
        this.emailErrorTips[type] = '';
      },
      //【职位类型】获取各种筛选项
      async get_search_conditions() {
        conditions.degrees[0][0] = '不限'
        conditions.experiences[0][0] = '不限'
        this.search_conditions = conditions;

      },
      //【城市】搜索城市名称
      citySearch(queryString, cb) {
        queryString = queryString.trim();
        this.formData.cities = queryString;
        cb([]);
        if (!queryString) {
          return false;
        }
        actions.staticApi.city_auto_completions({keyword: queryString}).then(res => {
          if (res.code === 1000) {
            let cities = res.data.filter(function (v) {
              return v.name !=='全国'
            })
            this.searchIngCityList = cities
            cb([...cities]);
          }
        })

      },
      //【城市】点击城市筛选项
      handleCity(item) {
        this.formData.cities = item.name;
      },
      //【城市】城市高亮html
      cityHtml(item) {
        let cityNames = item.split(this.formData.cities).filter(sitem => sitem);
        if (this.formData.cities === item) {
          return `<span class="color_blue">${item}</span>`
        } else if (cityNames.length === 1) {
          if (item.indexOf(this.formData.cities) === 0) {
            return `<span class="color_blue">${this.formData.cities}</span>${cityNames[0]}`
          } else {
            return `${cityNames[0]}<span class="color_blue">${this.formData.cities}</span>`
          }
        } else {
          return `${cityNames[0]}<span class="color_blue">${this.formData.cities}</span>${cityNames[1]}`
        }
      },
      //【城市】失焦
      cityBlur() {
        setTimeout(() => {
          let formDataCity = this.formData.cities.trim();
          let cities = this.getCityData(formDataCity);
          if (cities.id) {
            this.formData.city_ids = cities.id;
            this.formData.cities = formDataCity;
            //同步城市数据
            this.updateCity({
              cities: formDataCity,
              city_ids: cities.id,
            })
          } else {
            this.formData.city_ids = '';
            this.formData.cities = '';
            //同步城市数据
            this.updateCity({
              cities: '',
              city_ids: '',
            })
            //同步地址数据
            this.updateCoordinate({
              addresses: '',
              coordinate: '', //经度,纬度
            })
          }
        }, 100);
      },
      // 切换招聘类型
      toggleJobNature(value) {
        if (this.formData.job_nature === value) {
          return false;
        }
        //更新招聘类型
        this.formData.job_nature = value;
        //更新最低薪资的数据
        this.getSalaryMinList();
        if (value === '全职' || value === '校招') {
          this.formData.salary_type = '月薪'; //日薪/月薪
          this.formData.salary_min = ''; //薪水下限
          //获取 最高 薪资的数据
          this.getSalaryMaxList();
          this.formData.salary_max = ''; //薪水上限
        } else {
          this.formData.salary_type = '日薪'; //日薪/月薪
          this.formData.salary_min = 100; //薪水下限
          //获取 最高 薪资的数据
          this.getSalaryMaxList();
          this.formData.salary_max = 150; //薪水上限`
        }
        if (value === '实习') {
          this.formData.experience = '0,0';
        } else {
          this.formData.experience = '';
        }
        // 招聘类型是校招的情况下，经验要求固定为应届生并且不可选
        if (value === '校招') {
          this.formData.experience = ',0'
          this.formData.deadline = ''
          this.formData.graduate_times = [this.moment().format('YYYY')]
          this.formData.annual_month_salary = 12
        }
        if(value !== '校招' || value !== '实习'){
          this.formData.graduate_times = []
        }
      },
      // 保存表单
      async saveForm() {
        let formData = JSON.parse(JSON.stringify(this.formData));
        // let { id, name, logo, intro} = this.companyInfo;
        formData.job_post = formData.job_post.trim();
        if (this.saveFormState || this.checkFormState) {
          return false;
        }
        if (!formData.job_post) {
          this.errorTips.job_post = '请输入职位名称';
          return false;
        }
        //整理职位类别
        formData.profession_id = this.profession_id

        formData.cities = formData.cities.trim();
        if (formData.cities.length) {
          let cities = this.getCityData(formData.cities);
          if (!!cities.city_name) {
            formData.cities = [formData.cities];
            formData.city_ids = [cities.id];
            formData.addresses = [this.coordinate.addresses];
            formData.positions = [this.coordinate.coordinate];
          } else {
            formData.city_ids = [];
            formData.cities = [];
            formData.addresses = [];
            formData.positions = []
          }
        } else {
          formData.city_ids = [];
          formData.cities = [];
          formData.addresses = [];
          formData.positions = []
        }
        formData.job_tags = this.job_tags;
        // formData.profession_id = this.profession_id;

        // let company = {
        //   id,
        //   intro,
        //   logo,
        //   name,
        // }
        // formData.company_id = company.id;
        formData.companyInfo = this.saveCompanyInfo;
        formData = this.checkVal(formData)
        formData.status = 'draft';
        formData.experience = formData.experience == '不限' ? '' : formData.experience
        formData.degree_id = formData.degree_id == '不限' ? null : formData.degree_id
        this.saveFormState = true;
        let res = {}
        if (this.pageType === 'create') {
          res = await actions.recruit_infos.create_recruit(formData);
        } else {
          res = await actions.recruit_infos.put_recruit(this.pageType, formData);
        }
        this.saveFormState = false;
        if (res.code === 1000) {
          this.$message({
            message: this.pageType === 'create' ? '职位创建成功' : '职位保存成功',
            type: 'success'
          });
          setTimeout(() => {
            this.$router.push({path: '/talent/joblist?status=draft'})
          }, 1000);
          return false;
        } else {
          if (res.code === 9000) {
            // 超出数量限制
            this.tipsState = 2;
            this.tipsShowState = true;
            return false;
          } else if (res.code === 9001) {
            // 重复职位
            this.tipsState = 4;
            this.tipsShowState = true;
            return false;
          }
          this.$message.error(res.message);
        }
      },
      // 检查表单完整性
      async checkForm() {
        let formData = JSON.parse(JSON.stringify(this.formData));
        let formState = true;
        if (this.saveFormState || this.checkFormState) {
          return false;
        }
        // 显示职位类别/关键词
        this.showLevelState = true;

        formData.job_post = formData.job_post.trim();
        let {
          job_post,//职位名称
          jd,//职位描述
          addresses,//工作地点
          cities,//工作地点
          email, //邮箱
          experience,//工作经验
          degree_id,//学历
          job_nature,
          deadline, // 投递截止日期
          graduate_times // 毕业时间
        } = formData;

        // 是否滚动到错误位置
        let errorTipsScroll = false;

        if (!job_post) {
          this.errorTips.job_post = '请输入职位名称';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'job_post');
          errorTipsScroll = true;
          formState = false;
        }
        if (!cities || !this.coordinate.coordinate) {
          this.errorTips.cities = '请输入工作地点';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'cities');
          errorTipsScroll = true;
          formState = false;
        }

        if ((job_nature !== '实习' && !experience) || !degree_id) {
          if ((job_nature !== '实习' && !experience) && !degree_id) {
            this.errorTips.experience_degree_id = '请选择经验学历要求'
          } else if ((job_nature !== '实习' && !experience) && degree_id) {
            this.errorTips.experience_degree_id = '请选择经验要求'
          } else if (experience && !degree_id) {
            this.errorTips.experience_degree_id = '请选择学历要求'
          }
          this.scrollToErrorTips(errorTipsScroll, 'experience_degree_id');
          errorTipsScroll = true;
          formState = false;
        }


        if ((formData.salary_min === '' || formData.salary_min === null) && formData.job_nature !== '校招') {
          //获取薪资数据时会触发清空薪资描述
          setTimeout(() => {
            this.errorTips.salary_min = '请选择薪资范围';
          }, 10);
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'salary_min');
          errorTipsScroll = true;
          formState = false;
        }
        if (!jd) {
          this.errorTips.jd = '请输入职位描述';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'jd');
          errorTipsScroll = true;
          formState = false;
        } else if (jd.length < 50) {
          this.errorTips.jd = '职位描述不少于50字';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'jd');
          errorTipsScroll = true;
          formState = false;
        }
        if (!this.job_tags.length) {
          this.errorTips.job_tags = '请选择职位关键词';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'job_tags');
          errorTipsScroll = true;
          formState = false;
        }
        if (!this.profession_id) {
          this.errorTips.profession_id = '请选择职位类别';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'profession_id');
          errorTipsScroll = true;
          formState = false;
        }
        if (!email) {
          this.errorTips.email = '请输入邮箱地址';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'email');
          errorTipsScroll = true;
          formState = false;
        }
        if (!deadline && formData.job_nature === '校招') {
          this.errorTips.deadline = '请选择招聘截止时间';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'deadline');
          errorTipsScroll = true;
          formState = false;
        }
        if ((!graduate_times || !graduate_times.length) && formData.job_nature === '校招') {
          this.errorTips.graduate_times = '请选择毕业时间';
          //滚动到错误的位置
          this.scrollToErrorTips(errorTipsScroll, 'graduate_times');
          errorTipsScroll = true;
          formState = false;
        }

        if (!formState) {
          return false;
        }
        //整理职位类别
        formData.profession_id = this.profession_id;
        //整理职位标签
        formData.job_tags = this.job_tags;

        formData.cities = formData.cities.trim();
        if (formData.cities.length) {
          let cities = this.getCityData(formData.cities);
          if (!!cities.city_name) {
            formData.cities = [formData.cities];
            formData.city_ids = [cities.id];
            formData.addresses = [this.coordinate.addresses];
            formData.detailed_address = this.coordinate.detailed_address
            formData.positions = [this.coordinate.coordinate];
          } else {
            formData.city_ids = [];
            formData.cities = [];
            formData.addresses = [];
            formData.positions = [];
            formData.detailed_address = null
          }
        } else {
          formData.city_ids = [];
          formData.cities = [];
          formData.addresses = [];
          formData.positions = [];
          formData.detailed_address = null
        }

        formData.companyInfo = this.saveCompanyInfo;
        formData = this.checkVal(formData)
        formData.experience = formData.experience == '不限' ? '' : formData.experience
        formData.degree_id = formData.degree_id == '不限' ? null : formData.degree_id
        formData.status = 'publish';
        formData.graduate_times.sort((a, b) => a-b) // 按从小到大排序
        this.checkFormState = true;
        let res = {}
        if (this.pageType === 'create') {
          res = await actions.recruit_infos.create_recruit(formData);
        } else {
          res = await actions.recruit_infos.put_recruit(this.pageType, formData);
        }
        this.checkFormState = false;
        if (res.code === 1000) {
          this.$message({
            message: '职位发布成功',
            type: 'success'
          });
          this.jobToken = res.data.job.token
          this.toInterview()
          return false;
        } else if (res.code === 9003) {
          console.log(this.$route.params );
          const { hotPublish, orderToken, token } = this.$route.params 
          if (hotPublish && orderToken) {
            // 从职位列表页点击发布火爆职位进来的，监听上次创建的订单，不需要创建新订单
            this.jobToken = token
            this.orderToken = orderToken
            // 显示支付弹窗
            this.payDialogVisible = true
          } else {
            // 正常流程：发布火爆职位，创建新的订单，然后显示支付弹窗，并且监听订单状态
            this.jobToken = res.message.job.token
            this.jobName = res.message.job.job_post
            // 创建订单
            this.createOrder(res.message.job.token)
          }
        } else {
          if (res.code === 9000) {
            // 超出数量限制
            this.tipsState = 2;
            this.tipsShowState = true;
            return false;
          } else if (res.code === 9001) {
            // 重复职位
            this.tipsState = 3;
            this.tipsShowState = true;
            return false;
          }
          this.$message.error(res.message);
        }
      },
      // 关闭支付弹窗二次确认
      closePayDialog () {
        this.confirmDialogVisible = true
      },
      confirmDialogConfirm () {
        this.confirmDialogVisible = false
      },
      confirmDialogCancel () {
        this.confirmDialogVisible = false
        // 跳转到职位列表页
        this.$router.push({ name: 'talentJobList' })
      },
      paidFunc () {
        this.$message.success('支付成功')
        setTimeout(() => {
          this.$message({
            message: '职位发布成功',
            type: 'success'
          })
          this.toInterview()
        }, 1000)
      },
      // 跳转到 设置约面时间页
      toInterview () {
        this.$router.push({
          path: `/talent/interview/${this.jobToken}`,
          query: this.pageType === 'create' ? { origin: 'createJob' } : {}
        })
      },
      // 创建订单
      async createOrder (token) {
        try {
          let params = {
            plan: 'hot',
            job_token: token,
            hot_start_time: this.moment().format('YYYY-MM-DD')
          }
          let res = await actions.recruit_infos.create_order(params)
          if (res.code === 1000) {
            // 获取订单 token
            this.orderToken = res.data.order_token
            // 显示支付弹窗
            this.payDialogVisible = true
          }
        } catch (e) {
          console.log(e)
        }
      },
      //根据城市名匹配数据
      getCityData(cityName) {
        let {cities} = cityData;
        let city = {}
        cities.forEach(item => {
          item.part_cities.forEach(sitem => {
            if (sitem.city_name === cityName) {
              city = sitem
            }
          })
        })
        return city;
      },
      //【公司】获取公司详情
      getCompanyData(brand_company_token) {
        actions.company.get_company_companies(brand_company_token || this.userInfo.company_token, {type: 'hr'}).then(res => {
          if (res.code === 1000) {
            let {token, brand_token, company_full_name, company_tags, company_tags_hr, logo, logo_hr, size_max, size_min, industry_id, industry, company_type, description_hr, description, size, company_nick_name} = res.data;
            //公司规模
            if (size_max) {
              company_options.scale_options.forEach(item => {
                if (size_max <= item.max && !size) {
                  size = item.value
                }
              })
            }
            //整理行业id
            if (industry_id && industry && industry.cn) {
              company_options.industry_options.forEach(item => {
                if (industry.cn === item.label) {
                  res.data.industry_id = item.value
                }
              })
            }

            let companyInfo = {
              company_token: token,
              company_name: company_full_name || '',
              company_nick_name: company_nick_name || '',
              company_scale: size,
              company_scale_min: size_min,
              company_scale_max: size_max,
              company_nature: company_type,
              company_tags: company_tags_hr && company_tags_hr.length ? company_tags_hr : company_tags,
              company_industry_id: industry_id,
              company_industry_cls_cn_name: industry && industry.cn ? industry.cn : '',
              logo: logo || '',
              logo_hr: logo_hr || '',
              description: description_hr || description
            }
            this.companyInfo = res.data;
            this.saveCompanyInfo = companyInfo;
            if(brand_company_token){
              return
            }
            // if (!company_full_name || !(logo || logo_hr) || !company_type || !size || !industry_id) {
            //   this.$router.replace({path: `/talent/company?edit=true&backTo=${encodeURIComponent(window.location.href)}`})
            //   return
            // }
            if(brand_token){
              this.getCompanyData(brand_token)
            }

          }
        })
        // actions.hr_accounts.company_info(data).then(res=>{
        //   if(res.status.code === 1){
        //     this.companyInfo = res.company;
        //     let { name, logo, nature, scale, industry_name, intro } = res.company;
        //     // 判断完整完整度
        //     if(!name || !logo || !nature || !scale || !industry_name || !intro){
        //       this.$router.replace({path:`/talent/company?edit=true&backTo=${encodeURIComponent(window.location.href)}`})
        //     }
        //   }
        // })
      },
      //获取 最低 薪资的数据
      getSalaryMinList() {
        let salaryMinList = [];
        let {job_nature} = this.formData;
        if (job_nature === '全职' || job_nature === '校招' ) {
          // salaryMinList.push({
          //   value:'',
          //   label:'薪资面议'
          // })
          for (let i = 1; i < 100; i++) {
            salaryMinList.push({
              value: i,
              label: i
            })
          }
          salaryMinList.push({
            value: 100,
            label: '100k以上'
          })
        } else {
          for (let i = 1; i <= 100; i++) {
            salaryMinList.push({
              value: i * 10,
              label: i * 10
            })
          }
        }

        this.salaryMinList = salaryMinList;
      },
      //获取 最高 薪资的数据
      getSalaryMaxList() {
        let salaryMaxList = [];
        let {job_nature, salary_min} = this.formData;
        let salary_max = '';
        if (salary_min) {
          if (job_nature === '全职' || job_nature === '校招' ) {
            let max = salary_min <= 50 ? salary_min * 2 : 100;
            for (let i = salary_min + 1; i <= max; i++) {
              salaryMaxList.push({
                value: i,
                label: i
              })
            }
            salary_max = salary_min < 100 ? salary_min + 1 : ''
          } else {
            let max = salary_min / 10
            for (let i = max + 1; i <= max * 2; i++) {
              salaryMaxList.push({
                value: i * 10,
                label: i * 10
              })
            }
            salary_max = salary_min + 10
          }

        } else {
          salary_max = ''
        }

        this.formData.salary_max = salary_max
        this.salaryMaxList = salaryMaxList;
        this.errorTips.salary_min = ''
      },
      //过滤空字符串
      checkVal(formData) {
        let formData2 = JSON.parse(JSON.stringify(formData));
        for (let k in formData) {
          if (formData[k] === '' || formData[k] === null) {
            delete formData2[k]
          }
        }
        return formData2

      },
      //隐藏提示
      hideTips() {
        this.tipsShowState = false;
      },

      //【邮箱】弹出邮箱弹窗
      toggleBindEmailState(state) {
        this.showBindEmailState = state;
        this.errorTips.email = '';

        if (!state) {
          clearInterval(this.timeName);
          this.time = 60;
          this.getCodeState = false;
        }
      },
      //【邮箱】获取验证码
      getCode() {
        let {email, code} = this.emailData;
        //防抖
        if (this.getCodeState) {
          return false;
        }
        //对电子邮件的验证
        var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
        let hasCannotEmail = false;
        this.cannotEmail.forEach(item => {
          if (email.indexOf(item) > -1) {
            hasCannotEmail = true;
          }
        })
        if (hasCannotEmail || !myreg.test(email)) {
          this.emailErrorTips.email = '请填写有效的公司邮箱';
          return false;
        }
        this.getCodeState = true;
        let data = {
          receiver: email,
          type: 'email'
        }
        //发送验证码
        actions.hr_accounts.verification_codes(data).then(res => {
          if (res.code === 1000) {
            this.$message({
              message: '邮箱验证码已发送',
              type: 'success'
            });
            this.time = 59;
            this.codeTime();
          } else {
            this.getCodeState = false;
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
      },
      //【邮箱】保存
      async bindEmail() {
        let {email, code} = this.emailData;
        //对电子邮件的验证
        var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;

        let hasCannotEmail = false;
        this.cannotEmail.forEach(item => {
          if (email.indexOf(item) > -1) {
            hasCannotEmail = true;
          }
        })
        if (hasCannotEmail || !myreg.test(email)) {
          this.emailErrorTips.email = '请填写有效的公司邮箱';
          return false;
        }
        if (!code || code.length != 6) {
          this.emailErrorTips.code = '请输入正确的验证码';
          return false;
        }

        let data = {
          company_email: email,
          email_code: code,
        }
        //此处更新邮箱，是直接改账户信息里的
        actions.hr_accounts.company_emails(data).then(async res => {
          if (res.code === 1000) {
            this.formData.email = email;
            this.emailData = {
              email: '',
              code: ''
            }
            this.emailErrorTips = {
              email: '',
              code: ''
            }
            this.$message({
              message: '邮箱验证码验证成功',
              type: 'success'
            });
            //关闭绑定邮箱弹层
            this.toggleBindEmailState(false);
            //关闭反向绑定邮箱弹层
            this.hideUserBindEmailState();
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })

      },
      //【邮箱】倒计时
      codeTime() {
        this.timeName = setInterval(() => {
          if (this.time == 1) {
            clearInterval(this.timeName);
            this.time = 60;
            this.getCodeState = false;
            return false;
          }
          this.time = this.time - 1;

        }, 1000);
      },

      //【模板】获取模板信息
      async get_jd_temp() {
        let res = await actions.jd_temps.get_jd_temp_detail(this.jd_temp)
        //显示职位类别/关键词
        this.showLevelState = true;
        if (res.code === 1000) {
          let {data, job_title, profession_id, title} = res.data;
          var replaceStr = "\\&nbsp;";//*是特殊字符，要转义一下，加个杠。
          data = data.replace(new RegExp(replaceStr, 'gm'), '')
          data = data.replace(/\n职位描述：/g, '职位描述：')
          data = data.replace(/\n\n/g, '\n')
          this.formData.jd = data;
          this.formData.job_post = job_title || '';
          this.formData.profession_id = profession_id || '';
          //同步id
          this.updateProfessionId(profession_id || '');
          if (title) {
            let checkLevel3 = setInterval(() => {
              if (this.selectProfessionList.length) {
                clearInterval(checkLevel3);
                this.findSelectItem(title);
              }
            }, 500);
          }
          if (data) {
            //把当前职位描述同步到vuex
            this.updateStoreJd(data)
          }
          //获取职位类别
          this.getJdTemps();
        }
      },

      //【反向绑定】切换显示状态
      hideUserBindEmailState() {
        this.emailBindState = false;
      },
      //【反向绑定】显示手动绑定邮箱弹层
      showEmailBind() {
        //对电子邮件的验证
        var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
        let hasCannotEmail = false;
        this.cannotEmail.forEach(item => {
          if (this.emailData.email.indexOf(item) > -1) {
            hasCannotEmail = true;
          }
        })
        if (hasCannotEmail || !myreg.test(this.emailData.email)) {
          this.emailErrorTips.email = '请填写有效的公司邮箱';
          return false;
        }
        //显示手动弹窗弹层
        this.emailBindState = true;
        //同步是否正在编辑邮箱
        this.emailBindEdit = this.emailData.email;
        //关闭绑定邮箱弹层
        this.toggleBindEmailState(false);
      },
      //【反向绑定】绑定邮箱
      bindEmailConfirm(code) {
        let {email} = this.emailData;
        this.emailData.code = code

        //正在loading
        this.updateUserBindEmailState(true)
        let data = {
          company_email: email,
          email_code: code,
        }
        actions.hr_accounts.check_company_emails(data).then(async res => {
          if (res.code === 1000) {
            this.formData.email = email;
            this.emailData = {
              email: '',
              code: ''
            }
            this.emailErrorTips = {
              email: '',
              code: ''
            }
            this.$message({
              message: '邮箱验证码验证成功',
              type: 'success'
            });
            //关闭绑定邮箱弹层
            this.toggleBindEmailState(false);
            //关闭反向绑定邮箱弹层
            this.hideUserBindEmailState();
          } else {
            //正在loading
            this.updateUserBindEmailState(false)
            if (res.message === '系统未收到邮件，请重新发送邮件确认') {
              this.emailBindErrorState = true;
              return false;
            }
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })

      },
      //【反向绑定】取消错误提示
      hideEmailBindError() {
        this.emailBindErrorState = false;
      },
      //获取职位类型信息
      getJdTemps() {
        actions.jd_temps.profession_level_show({}).then(res => {
          if (res.code === 1000) {
            let {profession_id} = this.formData;
            let selectProfessionList = res.data;

            selectProfessionList.forEach(item => {
              item.level2List = [];
              item.list.forEach((sitem, sindex) => {
                let index2 = Math.floor(sindex / 2);
                if (!item.level2List[index2]) {
                  item.level2List[index2] = [];
                }
                item.level2List[index2].push(sitem)
              })
            })
            //同步列表数据
            this.updateSelectProfessionList(selectProfessionList)

            if (profession_id) {
              if (this.professionData) {
                let level2ListIndex = ''
                let level2ItemIndex = ''
                selectProfessionList.forEach((item, index) => {
                  if (item.title === this.professionData[0]) {
                    item.level2List.forEach((sitem, sindex) => {
                      sitem.forEach((ssitem, ssindex) => {
                        if (ssitem.title === this.professionData[1]) {
                          level2ListIndex = sindex;
                          level2ItemIndex = ssindex;
                        }
                      })
                    })
                  }
                })
                this.professionSelect.level2ListIndex = level2ListIndex
                this.professionSelect.level2ItemIndex = level2ItemIndex
                this.updateProfessionSelect(this.professionSelect);
              }
            } else {
              this.updateProfessionSelect({
                level1: selectProfessionList[0].title,
                level2: '',
                level3: '',
                level2ListIndex: '',
                level2ItemIndex: '',
              })
            }
          }
        })
      },
      //获取最近一个职位使用的地址
      getLastAddress() {
        actions.jobs.get_last_address().then(res => {
          if (res.code === 1000) {
            let {city_names, city_ids, addresses, positions, detailed_address} = res.data.last_address;

            let cities = city_names && city_names.length ? city_names[0] : '';
            city_ids = city_ids && city_ids.length ? city_ids[0] : '';
            let address = addresses && addresses.length && positions && positions.length ? addresses[0] : '';
            positions = addresses && addresses.length && positions && positions.length ? positions[0] : '';

            this.formData.cities = cities;
            this.formData.city_ids = city_ids;
            this.formData.addresses = address;
            this.formData.positions = positions;
            this.formData.detailed_address = detailed_address
            if (cities && city_ids) {
              //同步城市数据
              this.updateCity({
                cities,
                city_ids,
              })
            }
            if (cities && address) {
              //同步地址数据
              this.updateCoordinate({
                addresses: address,
                coordinate: positions, //经度, 纬度
                detailed_address,
              })
            }

          }
        })
      },
      //获取职位关键词
      getJobTags() {
        let tags = [];
        let {job_tags} = this.formData;

        //获取用户自定义添加的
        let user_add_tags = job_tags.filter(function (v) {
          return tags.indexOf(v) == -1
        });
        let user_add_tags2 = [];
        user_add_tags.forEach(item => {
          user_add_tags2.push({
            check: true,
            tag: item
          })
        })

        let user_check_tags = [];
        tags.forEach(item => {
          user_check_tags.push({
            check: [item].filter(v => job_tags.indexOf(v) > -1).length > 0,
            tag: item
          })
        })
        //更新用户选中tags
        this.updateUserCheckTags(user_check_tags);
        //更新用户自己添加的tags
        this.updateUserAddTags(user_add_tags2);
      },
      //更新错误信息
      updateErrorTips(options) {
        this.errorTips[options.type] = options.text;
      },
      //职位描述/职位名称 失焦
      levelChange(type) {
        if (this.jobPostBlurTimeState) {
          return
        }
        //清空提示
        this.errorTips.job_tags = '';
        this.errorTips.profession_id = '';

        if (this.userToggleProfession) {
          this.updateStoreJd(this.formData.jd)
        } else if (this.formData.job_post && this.formData.jd) {
          this.jobPostBlurTimeState = true;
          this.jobPostBlur();
          this.updateStoreJd(this.formData.jd)
        }
      },
      //职位名称失焦，
      jobPostBlur() {
        let {job_post, jd} = this.formData;
        this.showLevelState = true;
        actions.ml.classifierLevelAccurate({job_title: job_post, job_description: jd}).then(res => {
          if (res.code === 1000) {
            let { predicted_result } = res.data;
            // 查找level3对应的item
            this.findSelectItem(predicted_result.profession_str);
            this.jobPostBlurTimeState = false;
          }
        })
      },
      //查找level3对应的item
      findSelectItem(level3) {
        if (!level3) {
          return false
        }
        this.selectProfessionList.forEach(item => {
          item.level2List.forEach((sitem, sindex) => {
            sitem.forEach((level3Item, level3Index) => {
              level3Item.list.forEach((ssitem, ssindex) => {
                if (ssitem.title === level3) {
                  // console.log({
                  //   level1:item.title,
                  //   level2:level3Item.title,
                  //   level3:ssitem.title,
                  //   level2ListIndex:sindex,
                  //   level2ItemIndex:level3Index,
                  // })
                  //同步匹配上的信息
                  this.updateProfessionSelect({
                    level1: item.title,
                    level2: level3Item.title,
                    level3: ssitem.title,
                    level2ListIndex: sindex,
                    level2ItemIndex: level3Index,
                  })
                  //同步profession_id
                  this.updateProfessionId(ssitem.profession_id);
                }
              })
            })
          })
        })
      },
      //重置vuex
      resetVuex() {
        //清除职位模板
        this.updateProfessionSelect({
          level1: '',
          level2: '',
          level3: '',
          level2ListIndex: '',
          level2ItemIndex: '',
        })
        this.updateProfessionId('')
        //清除卡片
        this.updateJobTags([]);
        this.updateUserCheckTags([]);
        this.updateUserAddTags([]);
        //清除职位描述
        this.updateStoreJd('');
      },
      //错误提示，滚动到错误位置
      scrollToErrorTips(errorTipsScroll, type) {
        if (!errorTipsScroll) {
          let box = this.$refs[`errorTips_${type}`];
          window.scrollTo(0, box.offsetTop - 80);
        }
      },
      //选择经验学历后操作
      getExperienceDegreeId(type) {
        let {experience, degree_id, job_nature} = this.formData
        if(type === 'degree_id' && !degree_id){
          this.errorTips.experience_degree_id = '请选择学历要求'
        }else if(type === 'experience' && !experience){
          this.errorTips.experience_degree_id = '请选择经验要求'
        }else {
          this.errorTips.experience_degree_id = ""
        }
      }
    },
  }
</script>
<style lang="scss" scoped>
  ::v-deep .el-checkbox__inner{
    background-color: #4183FF;
    border-color: #4183FF;
  }
  @import './Index.scss';
  .job_post_num{
    right: 14px;
    bottom: 13px;
    top: 14px;
  }
  .iconwenhao{
    position: relative;
    font-size: 16px;
    cursor: pointer;
    &:hover{
      color: #606060;
      .bbs-hint{
        display: block;
      }
    }
  }
  .bbs-hint{
    position: absolute;
    width: 394px;
    height: 90px;
    background: rgba(0,0,0,0.8);
    left: 28px;top: -37px;
    border-radius: 6px;
    padding: 12px 14px;
    line-height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    box-sizing: border-box;
    display: none;
    &::after{
      content: "";
      width: 0;
      height: 0;
      position: absolute;
      border: 6px solid transparent;
      border-right-color: rgba(0,0,0,0.8);
      left: -12px;
      top: 40px;
    }
  }
</style>
